<template>
  <div class="content-wrapper supplier-goods-relation">
    <!-- Main content -->
    <div class="flex">
      <section class="content mr10" style="flex: 1">
        <section style="margin-bottom: 1%">
          <a-button type="primary" @click="createSupplierGoods">
            <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
            {{ $t('新建商品供应商关系') }}
          </a-button>
        </section>

        <a-row :gutter="24">
          <a-col :span="8">
            <SelectSupplier @supplierIndexChange="supplierIndexChange"></SelectSupplier>
          </a-col>
          <a-col :span="8">
            <a-button @click="queryOrderList(1)" class="btnBgc">
              <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
              {{ $t(`form.Search`) }}
            </a-button>
          </a-col>
        </a-row>

        <div class="table-content mt20">
          <div class="table-body">
            <a-table
              :columns="tableColumns"
              :data-source="tableData"
              :loading="tableLoading"
              rowKey="id"
              :pagination="false"
              bordered
            >
              <template slot="goodsInfo" slot-scope="text, record">
                <div>{{ $t('商品名称') }}: {{ record.skuName }}</div>
                <div>{{ $t('商品条码') }}: {{ record.barcode }}</div>
              </template>
              <template slot="time" slot-scope="text, record">
                <div>
                  <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.createdAt }}</div>
                </div>
              </template>
              <template slot="deliveryHour" slot-scope="text, record">
                <div class="flex-ct" v-if="record.editable">
                  <a-input
                    style="width: 150px"
                    v-model="record.deliveryHour"
                    :addon-after="$t('小时')"
                    @change="handleChange2(record)"
                  ></a-input>
                  <a-icon class="ml6 text-link" type="check-circle" @click="saveRecord(record)" />
                  <a-icon
                    class="ml6 text-link"
                    type="close-circle"
                    @click="queryOrderList(false)"
                  />
                </div>
                <template v-else>
                  <span class="mr6">{{ text }}</span>
                  <a-icon class="text-link" type="edit" @click="editHandle(record)" />
                </template>
              </template>
              <template slot="action" slot-scope="text, record">
                <a-popconfirm :title="$t('确定删除?')" @confirm="deleteHandle(record)">
                  <a-button type="link">{{ $t('删除') }}</a-button>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
          <div class="table-footer mt10">
            <pagination
              :pageNo="pageNo"
              :length="pageSize"
              :total-count="total"
              @paginate="paginate"
            ></pagination>
          </div>
        </div>
      </section>
      <OperationLog :list="orderActions" :defaultCollapsed="true" />
    </div>

    <a-modal
      v-model="visible"
      :title="$t('新建商品供应商关系')"
      width="800px"
      :confirmLoading="confirmLoading"
      @ok="saveSupplierGoodsRelation"
    >
      <div class="main-content">
        <a-form-model>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('选择供应商')" required>
                <SelectSupplier
                  ref="SelectSupplierRef"
                  style="width: 100%"
                  @supplierIndexChange="supplierIndexChange2"
                ></SelectSupplier>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('选择商品')" required>
                <SearchSku ref="SearchSkuRef" style="width: 100%" @selected="handleChangeSku" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('到货周期')" required>
                <a-input
                  style="width: 100%"
                  v-model="modalData.deliveryHour"
                  :addon-after="$t('小时')"
                  @change="handleChange"
                ></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>
<script>
import http from '@/service/axios'
import api from '@/service/api'
import pagination from '@component/pagination'
import SelectSupplier from '@component/selectSupplier'
import SearchSku from '@component/searchSku'
import debounce from '@/common/debounce'
import OperationLog from '@component/operationLog'
export default {
  name: 'SupplierGoodsRelation',
  activated() {
    this.queryOrderList()
  },
  components: {
    pagination,
    SelectSupplier,
    SearchSku,
    OperationLog,
  },
  data() {
    return {
      formData: {
        barcode: undefined,
        supplierCode: undefined,
      },
      modalData: {
        barcode: undefined,
        supplierCode: undefined,
        supplierName: undefined,
        skuName: undefined,
        deliveryHour: undefined,
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      tableLoading: false,
      visible: false,
      confirmLoading: false,

      orderActions: [],
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          title: this.$t('form.SupplierCode'),
          dataIndex: 'supplierCode',
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 240,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: this.$t('form.SupplierName'),
          dataIndex: 'supplierName',
          key: 'supplierName',
        },
        {
          title: this.$t('商品信息'),
          key: 'goodsInfo',
          scopedSlots: { customRender: 'goodsInfo' },
        },
        {
          width: 200,
          title: this.$t('到货周期'),
          dataIndex: 'deliveryHour',
          scopedSlots: { customRender: 'deliveryHour' },
        },
        {
          title: this.$t('form.VATRate') + '(%)',
          dataIndex: 'vatRate',
          scopedSlots: { customRender: 'vatRate' },
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'createdUser',
          customRender: (text) => decodeURIComponent(text),
        },
        {
          title: this.$t('操作'),
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    createSupplierGoods() {
      this.modalData = {
        barcode: undefined,
        supplierCode: undefined,
        supplierName: undefined,
        skuName: undefined,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.SelectSupplierRef.clear()
        this.$refs.SearchSkuRef.clear()
      })
    },
    deleteHandle(record) {
      http({
        type: 'post',
        url: api.removeSupplierGoodsRelation,
        hasLoading: true,
        data: {
          id: record.id,
        },
        success: (res) => {
          if (res.success) {
            this.$message.success(this.$t('layer.DeleteSuccess'))
            this.queryOrderList()
          }
        },
      })
    },

    queryOrderList(first_page = false) {
      this.getOrderActionList()
      first_page && (this.pageNo = 1)
      this.tableLoading = true
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supplierCode: this.formData.supplierCode,
        barcode: this.formData.barcode,
      }
      http({
        type: 'post',
        url: api.querySupplierGoodsRelationList,
        hasLoading: true,
        data,
        success: (res) => {
          let list = [...res.result.list]
          this.tableData = list
          this.total = res.result.total
          this.tableLoading = false
        },
      })
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    supplierIndexChange(val) {
      this.formData.supplierCode = val.supplierCode
    },
    supplierIndexChange2(val) {
      this.modalData.supplierCode = val.supplierCode
      this.modalData.supplierName = val.supplierName
    },
    handleChangeSku(data) {
      this.modalData.barcode = data.barcode
      this.modalData.skuName = data.skuName
    },
    saveSupplierGoodsRelation: debounce(function () {
      if (!this.modalData.supplierCode) {
        return this.$message.warning(this.$t('请选择供应商'))
      }
      if (!this.modalData.barcode) {
        return this.$message.warning(this.$t('layer.ProductRequired'))
      }
      if (!this.modalData.deliveryHour) {
        return this.$message.warning(this.$t('请输入到货周期'))
      }
      this.confirmLoading = true
      http({
        url: api.saveSupplierGoodsRelation,
        data: this.modalData,
        success: (res) => {
          if (res.success) {
            this.$message.success(this.$t('form.CreatedSuccessfully'))
            this.visible = false
            this.queryOrderList()
          }
          this.confirmLoading = false
        },
        fail: () => {
          this.confirmLoading = false
        },
      })
    }),

    getOrderActionList() {
      http({
        url: api.queryCommonActionList,
        type: 'post',
        data: {
          actionCategory: 'supplier_goods_relation',
          actionSn: this.$store.state.userSession.merchantCode,
        },
        hasLoading: false,
        success: (res) => {
          this.orderActions = res.result
        },
      })
    },
    handleChange() {
      // 只允许输入数字
      this.modalData.deliveryHour = this.modalData.deliveryHour.replace(/\D/g, '')
    },
    handleChange2(record) {
      // 只允许输入数字
      record.deliveryHour = record.deliveryHour.replace(/\D/g, '')
    },
    editHandle(record) {
      this.$set(record, 'editable', true)
    },
    saveRecord(record) {
      if (!record.deliveryHour) {
        return this.$message.warning(this.$t('请输入到货周期'))
      }
      http({
        url: api.saveSupplierGoodsRelation,
        data: {
          supplierCode: record.supplierCode,
          supplierName: record.supplierName,
          barcode: record.barcode,
          skuName: record.skuName,
          deliveryHour: record.deliveryHour,
        },
        success: (res) => {
          if (res.success) {
            this.$message.success(this.$t('form.SuccessfullyModified'))
            this.$set(record, 'editable', false)
          }
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.time-item {
  font-size: 13px;
}
</style>
